import { IconAiToolClaude, IconAiToolMidjourney } from "@/lib/images";
import { StaticImageData } from "next/image";

interface IAiToolLogo {
    name: string;
    src: StaticImageData;
    alt: string;
}

export const BornReadyAIEraData = {
    title: "Born Ready for the AI Era",
    description: "Smarter workflows start with smarter prompts. At Devkrest, AI isn't an add-on — it's a teammate we prompt, test, and refine across engineering, design, and ops.",
    logos: [
        {
            name: "Claude",
            src: IconAiToolClaude,
            alt: "Claude"
        },
        {
            name: "Midjourney",
            src: IconAiToolMidjourney,
            alt: "Midjourney"
        }
    ] as IAiToolLogo[]
}; 